export default __webpack_public_path__ + "static/Tree-life-pana-white-00c9fd11d1f4677553099e9e6452a250.png";